export default "__VITE_ASSET__DkIaQU5B__"